<template>
	<div ref="target" class="sidePanelContent flex h-screen">
		<CloseBar v-if="withCloseBar" @close="close(true)" />

		<div class="sidePanelContentInner overflow-custom-scroll flex h-screen flex-1 flex-col justify-between">
			<div class="headingAndContent grid h-full grid-rows-[auto_1fr] overflow-y-hidden">
				<div class="heading font-header-h3-bold bg-level-01 p-05 text-[1.125rem] text-ink-100">
					<slot name="heading"></slot>
				</div>

				<div class="overflow-y-auto px-05 py-03">
					<slot></slot>
				</div>
			</div>

			<div v-if="slots.footer" class="footer mt-05">
				<slot name="pre-footer"></slot>

				<div class="p-05">
					<slot name="footer"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { onClickOutside } from '@vueuse/core'
import { toRefs, useTemplateRef } from 'vue'
import CloseBar from '@/features/sidePanel/components/CloseBar.vue'
import { useSidebarStore } from '@/features/sidePanel/useSidebarStore'
import { type SidebarContent } from '@/types'

const { closeSidebar } = useSidebarStore()

const props = defineProps<{
	type?: SidebarContent
	withCloseBar?: boolean
	hideOnClickOutside?: boolean
}>()

const { type, hideOnClickOutside } = toRefs(props)

const emit = defineEmits(['close'])

const slots = defineSlots()

const clickOutsideTarget = useTemplateRef('target')

function close(viaCloseBar = false) {
	if (!type.value) {
		return
	}

	closeSidebar(type.value, !viaCloseBar)

	emit('close')
}

onClickOutside(clickOutsideTarget, () => {
	if (!hideOnClickOutside.value) {
		return
	}

	close()
})
</script>

<style lang="scss" scoped>
.footer {
	border-top: solid 0.0625rem theme('colors.ink.12');
}
</style>
